// components/CRM/EtapaWorkflow/ContactoInicialForm.jsx
import React, { useState } from 'react';
import {
  Box, Typography, TextField, Button, Grid, FormControl,
  InputLabel, Select, MenuItem, Rating, Paper, Alert
} from '@mui/material';
import { Save as SaveIcon } from '@mui/icons-material';


const ContactoInicialForm = ({ oportunidad, onGuardado, onTransicionCompleta }) => {
  const [datos, setDatos] = useState({
    primer_contacto_fecha: new Date().toISOString().split('T')[0],
    medio_preferido: 'whatsapp',
    calificacion_bant: {
      budget: 3,
      authority: 3,
      need: 3,
      timeline: 3
    },
    notas: ''
  });
  const [guardando, setGuardando] = useState(false);

  const handleGuardar = async () => {
    setGuardando(true);
    try {
      // ✅ PATRÓN CORRECTO: Solo pasar datos a onGuardado
      // El TransicionEtapaModal se encarga de hacer la transición
      if (onGuardado) {
        await onGuardado({
          primer_contacto_fecha: datos.primer_contacto_fecha,
          medio_preferido: datos.medio_preferido,
          calificacion_bant: datos.calificacion_bant,
          notas: datos.notas
        });
      }

      // El modal se cierra automáticamente después de la transición exitosa
      if (onTransicionCompleta) {
        onTransicionCompleta();
      }
    } catch (error) {
      console.error('Error:', error);
      alert('Error al guardar');
    } finally {
      setGuardando(false);
    }
  };

  const getScoreLabel = (value) => {
    const labels = ['Muy bajo', 'Bajo', 'Medio', 'Alto', 'Muy alto'];
    return labels[value - 1] || '';
  };

  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="h5" gutterBottom fontWeight="bold">
        📞 Contacto Inicial - Calificación
      </Typography>
      
      <Alert severity="info" sx={{ mb: 3 }}>
        Registre el primer contacto y califique al prospecto usando la metodología BANT
      </Alert>

      <Grid container spacing={3}>
        <Grid item xs={12} md={6}>
          <TextField
            fullWidth
            label="Fecha de primer contacto"
            type="date"
            value={datos.primer_contacto_fecha}
            onChange={(e) => setDatos({...datos, primer_contacto_fecha: e.target.value})}
            InputLabelProps={{ shrink: true }}
          />
        </Grid>
        
        <Grid item xs={12} md={6}>
          <FormControl fullWidth>
            <InputLabel>Medio de contacto preferido</InputLabel>
            <Select
              value={datos.medio_preferido}
              onChange={(e) => setDatos({...datos, medio_preferido: e.target.value})}
            >
              <MenuItem value="whatsapp">WhatsApp</MenuItem>
              <MenuItem value="llamada">Llamada telefónica</MenuItem>
              <MenuItem value="email">Correo electrónico</MenuItem>
              <MenuItem value="reunion">Reunión presencial</MenuItem>
            </Select>
          </FormControl>
        </Grid>

        {/* BANT Scoring */}
        <Grid item xs={12}>
          <Paper sx={{ p: 3, bgcolor: '#f8fafc' }}>
            <Typography variant="h6" gutterBottom color="primary">
              Calificación BANT
            </Typography>
            
            {[
              { key: 'budget', label: 'Budget (Presupuesto)', desc: '¿Tiene capacidad de pago?' },
              { key: 'authority', label: 'Authority (Autoridad)', desc: '¿Es el decisor?' },
              { key: 'need', label: 'Need (Necesidad)', desc: '¿Qué tan urgente es?' },
              { key: 'timeline', label: 'Timeline (Tiempo)', desc: '¿Cuándo decide?' }
            ].map((item) => (
              <Box key={item.key} sx={{ mb: 3 }}>
                <Typography variant="subtitle2" fontWeight="bold">
                  {item.label}
                </Typography>
                <Typography variant="caption" color="text.secondary" display="block" sx={{ mb: 1 }}>
                  {item.desc}
                </Typography>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                  <Rating
                    value={datos.calificacion_bant[item.key]}
                    onChange={(e, val) => setDatos({
                      ...datos,
                      calificacion_bant: {
                        ...datos.calificacion_bant,
                        [item.key]: val
                      }
                    })}
                    max={5}
                  />
                  <Typography variant="body2" color="primary">
                    {getScoreLabel(datos.calificacion_bant[item.key])}
                  </Typography>
                </Box>
              </Box>
            ))}
          </Paper>
        </Grid>

        <Grid item xs={12}>
          <TextField
            fullWidth
            label="Notas del primer contacto"
            multiline
            rows={4}
            value={datos.notas}
            onChange={(e) => setDatos({...datos, notas: e.target.value})}
            placeholder="Resumen de la conversación, intereses del cliente, próximos pasos..."
          />
        </Grid>
      </Grid>

      <Box sx={{ mt: 3, display: 'flex', justifyContent: 'flex-end' }}>
        <Button
          variant="contained"
          startIcon={<SaveIcon />}
          onClick={handleGuardar}
          disabled={guardando}
          size="large"
        >
          {guardando ? 'Guardando...' : 'Guardar y Continuar'}
        </Button>
      </Box>
    </Box>
  );
};

export default ContactoInicialForm;